/*
 *
 * ConnectionManager constants
 *
 */

export const CONNECT = 'app/ConnectionManager/CONNECT';
export const CONNECT_SUCCESS = 'app/ConnectionManager/CONNECT_SUCCESS';
export const CONNECT_ERROR = 'app/ConnectionManager/CONNECT_ERROR';
export const DISCONNECT = 'app/ConnectionManager/DISCONNECT';
export const REQUEST_ERROR = 'app/ConnectionManager/REQUEST_ERROR';

// Commands
export const COMMAND_IAM_SUBSCRIPTION_USER_LIST = 'app/ConnectionManager/commands/IAM_SUBSCRIPTION_USER_LIST';
export const COMMAND_IAM_SUBSCRIPTION_TEAM_LIST = 'app/ConnectionManager/commands/IAM_SUBSCRIPTION_TEAM_LIST';
export const COMMAND_AUTHOR_PLUGIN_GET = 'app/ConnectionManager/commands/AUTHOR_PLUGIN_GET';
export const COMMAND_AUTHOR_PLUGIN_LIST = 'app/ConnectionManager/commands/AUTHOR_PLUGIN_LIST';
export const COMMAND_AUTHOR_PLUGIN_VERSION_DELETE = 'app/ConnectionManager/commands/AUTHOR_PLUGIN_VERSION_DELETE';
export const COMMAND_AUTHOR_PLUGIN_VERSION_UNPUBLISH = 'app/ConnectionManager/commands/AUTHOR_PLUGIN_VERSION_UNPUBLISH';
export const COMMAND_WORKSPACE_PLUGIN_LIST = 'app/ConnectionManager/commands/WORKSPACE_PLUGIN_LIST';
export const COMMAND_WORKSPACE_PLUGIN_VERSION_LIST = 'app/ConnectionManager/commands/WORKSPACE_PLUGIN_VERSION_LIST';
export const COMMAND_WORKSPACE_PLUGIN_DETAILS = 'app/ConnectionManager/commands/WORKSPACE_PLUGIN_DETAILS';
export const COMMAND_WORKSPACE_PLUGIN_CREATE = 'app/ConnectionManager/commands/WORKSPACE_PLUGIN_CREATE';
export const COMMAND_WORKSPACE_PLUGIN_COLLABORATOR_SUMMARY = 'app/ConnectionManager/commands/WORKSPACE_PLUGIN_COLLABORATOR_SUMMARY';
export const COMMAND_WORKSPACE_PLUGIN_PERMISSION_GRANT = 'app/ConnectionManager/commands/WORKSPACE_PLUGIN_PERMISSION_GRANT';
export const COMMAND_WORKSPACE_PLUGIN_PERMISSION_REVOKE = 'app/ConnectionManager/commands/WORKSPACE_PLUGIN_PERMISSION_REVOKE';
export const COMMAND_WORKSPACE_PLUGIN_DELETE = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_PLUGIN_DELETE';
export const COMMAND_WORKSPACE_PLUGIN_UPDATE = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_PLUGIN_UPDATE';
export const COMMAND_WORKSPACE_COHORT_LIST = 'app/ConnectionManager/commands/WORKSPACE_COHORT_LIST';
export const COMMAND_WORKSPACE_COHORT = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_COHORT';
export const COMMAND_WORKSPACE_COHORT_CREATE = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_COHORT_CREATE';
export const COMMAND_WORKSPACE_COHORT_CHANGE = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_COHORT_CHANGE';
export const COMMAND_WORKSPACE_COHORT_COLLABORATOR_SUMMARY = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_COHORT_COLLABORATOR_SUMMARY';
export const COMMAND_WORKSPACE_COHORT_ARCHIVE = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_COHORT_ARCHIVE';
export const COMMAND_GRANT_PERMISSION_ON_COHORT = 'app/ConnectionManager/commands/COMMAND_GRANT_PERMISSION_ON_COHORT';
export const COMMAND_REVOKE_PERMISSION_ON_COHORT = 'app/ConnectionManager/commands/COMMAND_REVOKE_PERMISSION_ON_COHORT';
export const COMMAND_WORKSPACE_COHORT_ENROLLMENTS_LIST = 'app/ConnectionManager/commands/WORKSPACE_COHORT_ENROLLMENTS_LIST';
export const COMMAND_WORKSPACE_DEPLOYMENT_LIST = 'app/ConnectionManager/commands/WORKSPACE_DEPLOYMENT_LIST';
export const COMMAND_WORKSPACE_PUBLICATIONS_LIST = 'app/ConnectionManager/commands/WORKSPACE_PUBLICATIONS_LIST';

export const COMMAND_WORKSPACE_ACTIVITY_LIST = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_ACTIVITY_LIST';
export const COMMAND_WORKSPACE_ACCOUNT_CREATE = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_ACCOUNT_CREATE';
export const COMMAND_WORKSPACE_ACCOUNTS_LIST = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_ACCOUNTS_LIST';
export const COMMAND_WORKSPACE_CREATE = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_CREATE';
export const COMMAND_WORKSPACE_COHORT_ACCOUNT_ENROLL = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_COHORT_ACCOUNT_ENROLL';
export const COMMAND_WORKSPACE_ACTIVITY_PUBLISH = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_ACTIVITY_PUBLISH';
export const COMMAND_WORKSPACE_COURSEWARE_META_INFO_GET = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_COURSEWARE_META_INFO_GET';
export const COMMAND_WORKSPACE_COURSEWARE_META_INFO_SET = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_COURSEWARE_META_INFO_SET';

export const COMMAND_IAM_TEAM_CREATE = 'app/ConnectionManager/commands/COMMAND_IAM_TEAM_CREATE';
export const COMMAND_IAM_TEAM_LIST = 'app/ConnectionManager/commands/IAM_TEAM_LIST';
export const COMMAND_WORKSPACE_WORKSPACES_LIST = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_WORKSPACES_LIST';
export const COMMAND_WORKSPACE_GRANT_PERMISSION = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_GRANT_PERMISSION';
export const COMMAND_WORKSPACE_REVOKE_PERMISSION = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_REVOKE_PERMISSION';
export const COMMAND_WORKSPACE_COLLABORATOR_SUMMARY = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_COLLABORATOR_SUMMARY';

export const COMMAND_GRANT_PERMISSION_ON_TEAM = 'app/ConnectionManager/commands/COMMAND_GRANT_PERMISSION_ON_TEAM';
export const COMMAND_REVOKE_PERMISSION_ON_TEAM = 'app/ConnectionManager/commands/COMMAND_REVOKE_PERMISSION_ON_TEAM';
export const COMMAND_IAM_TEAM_ACCOUNT_SUMMARY = 'app/ConnectionManager/commands/COMMAND_IAM_TEAM_ACCOUNT_SUMMARY';

export const COMMAND_WORKSPACE_PROJECT_LIST = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_PROJECT_LIST';
export const COMMAND_WORKSPACE_PROJECT_CREATE = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_PROJECT_CREATE';
export const COMMAND_PROJECT_ACTIVITY_PUBLISH = 'app/ConnectionManager/commands/COMMAND_PROJECT_ACTIVITY_PUBLISH';
export const COMMAND_WORKSPACE_PROJECT_INGEST_LIST = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_PROJECT_INGEST_LIST';
export const COMMAND_WORKSPACE_PROJECT_INGEST_GET = 'app/ConnectionManager/commands/COMMAND_WORKSPACE_PROJECT_INGEST_GET';
// API layer constants
export const RTM_ME_GET = 'me.get';

export const RTM_IAM_SUBSCRIPTION_USER_LIST = 'iam.subscription.user.list';
export const RTM_IAM_SUBSCRIPTION_USER_LIST_OK = 'iam.subscription.user.list.ok';
export const RTM_IAM_SUBSCRIPTION_USER_LIST_ERROR = 'iam.subscription.user.list.error';

export const RTM_IAM_SUBSCRIPTION_TEAM_LIST = 'iam.subscription.team.list';
export const RTM_IAM_SUBSCRIPTION_TEAM_LIST_OK = 'iam.subscription.team.list.ok';
export const RTM_IAM_SUBSCRIPTION_TEAM_LIST_ERROR = 'iam.subscription.team.list.error';

export const RTM_IAM_SUBSCRIPTION_USER_PROVISION = 'iam.subscription.user.provision';
export const RTM_IAM_SUBSCRIPTION_USER_PROVISION_OK = 'iam.subscription.user.provision.ok';
export const RTM_IAM_SUBSCRIPTION_USER_PROVISION_ERROR = 'iam.subscription.user.provision.error';

export const RTM_AUTHOR_PLUGIN_GET = 'author.plugin.get';
export const RTM_AUTHOR_PLUGIN_GET_OK = 'author.plugin.get.ok';
export const RTM_AUTHOR_PLUGIN_GET_ERROR = 'author.plugin.get.error';

export const RTM_AUTHOR_PLUGIN_LIST = 'author.plugin.list';
export const RTM_AUTHOR_PLUGIN_LIST_OK = 'author.plugin.list.ok';
export const RTM_AUTHOR_PLUGIN_LIST_ERROR = 'author.plugin.list.error';

export const RTM_AUTHOR_PLUGIN_VERSION_DELETE = 'author.plugin.version.delete';
export const RTM_AUTHOR_PLUGIN_VERSION_DELETE_OK = 'author.plugin.version.delete.ok';
export const RTM_AUTHOR_PLUGIN_VERSION_DELETE_ERROR = 'author.plugin.version.delete.error';

export const RTM_AUTHOR_PLUGIN_VERSION_UNPUBLISH = 'author.plugin.version.unpublish';
export const RTM_AUTHOR_PLUGIN_VERSION_UNPUBLISH_OK = 'author.plugin.version.unpublish.ok';
export const RTM_AUTHOR_PLUGIN_VERSION_UNPUBLISH_ERROR = 'author.plugin.version.unpublish.error';

export const RTM_WORKSPACE_PLUGIN_LIST = 'workspace.plugin.list';
export const RTM_WORKSPACE_PLUGIN_LIST_OK = 'workspace.plugin.list.ok';
export const RTM_WORKSPACE_PLUGIN_LIST_ERROR = 'workspace.plugin.list.error';

export const RTM_WORKSPACE_PLUGIN_VERSION_LIST = 'workspace.plugin.version.list';
export const RTM_WORKSPACE_PLUGIN_VERSION_LIST_OK = 'workspace.plugin.version.list.ok';
export const RTM_WORKSPACE_PLUGIN_VERSION_LIST_ERROR = 'workspace.plugin.version.list.error';

export const RTM_WORKSPACE_PLUGIN_DETAILS = 'workspace.plugin.get';
export const RTM_WORKSPACE_PLUGIN_DETAILS_OK = 'workspace.plugin.get.ok';
export const RTM_WORKSPACE_PLUGIN_DETAILS_ERROR = 'workspace.plugin.get.error';

export const RTM_PROJECT_INGEST_GET = 'project.ingest.get';
export const RTM_PROJECT_INGEST_GET_OK = 'project.ingest.get.ok';
export const RTM_PROJECT_INGEST_GET_ERROR = 'project.ingest.get.error';

export const RTM_WORKSPACE_PLUGIN_CREATE = 'workspace.plugin.create';
export const RTM_WORKSPACE_PLUGIN_CREATE_OK = 'workspace.plugin.create.ok';
export const RTM_WORKSPACE_PLUGIN_CREATE_ERROR = 'workspace.plugin.create.error';

export const RTM_WORKSPACE_PLUGIN_UPDATE = 'workspace.plugin.update';
export const RTM_WORKSPACE_PLUGIN_UPDATE_OK = 'workspace.plugin.update.ok';
export const RTM_WORKSPACE_PLUGIN_UPDATE_ERROR = 'workspace.plugin.update.error';

export const RTM_WORKSPACE_PLUGIN_COLLABORATOR_SUMMARY = 'workspace.plugin.collaborator.summary';
export const RTM_WORKSPACE_PLUGIN_COLLABORATOR_SUMMARY_OK = 'workspace.plugin.collaborator.summary.ok';
export const RTM_WORKSPACE_PLUGIN_COLLABORATOR_SUMMARY_ERROR = 'workspace.plugin.collaborator.summary.error';

export const RTM_WORKSPACE_PLUGIN_PERMISSION_GRANT = 'workspace.plugin.permission.grant';
export const RTM_WORKSPACE_PLUGIN_PERMISSION_GRANT_OK = 'workspace.plugin.permission.grant.ok';
export const RTM_WORKSPACE_PLUGIN_PERMISSION_GRANT_ERROR = 'workspace.plugin.permission.grant.error';

export const RTM_WORKSPACE_PLUGIN_PERMISSION_REVOKE = 'workspace.plugin.permission.revoke';
export const RTM_WORKSPACE_PLUGIN_PERMISSION_REVOKE_OK = 'workspace.plugin.permission.revoke.ok';
export const RTM_WORKSPACE_PLUGIN_PERMISSION_REVOKE_ERROR = 'workspace.plugin.permission.revoke.error';

export const RTM_WORKSPACE_COHORT_LIST = 'workspace.cohort.list';
export const RTM_WORKSPACE_COHORT_LIST_OK = 'workspace.cohort.list.ok';
export const RTM_WORKSPACE_COHORT_LIST_ERROR = 'workspace.cohort.list.error';

export const RTM_WORKSPACE_COHORT = 'workspace.cohort.get';
export const RTM_WORKSPACE_COHORT_OK = 'workspace.cohort.get.ok';
export const RTM_WORKSPACE_COHORT_ERROR = 'workspace.cohort.get.error';

export const RTM_WORKSPACE_COHORT_CREATE = 'workspace.cohort.create';
export const RTM_WORKSPACE_COHORT_CREATE_OK = 'workspace.cohort.create.ok';
export const RTM_WORKSPACE_COHORT_CREATE_ERROR = 'workspace.cohort.create.error';

export const RTM_WORKSPACE_COHORT_CHANGE = 'workspace.cohort.change';
export const RTM_WORKSPACE_COHORT_CHANGE_OK = 'workspace.cohort.change.ok';
export const RTM_WORKSPACE_COHORT_CHANGE_ERROR = 'workspace.cohort.change.error';

export const RTM_WORKSPACE_COHORT_COLLABORATOR_SUMMARY = 'workspace.cohort.collaborator.summary';
export const RTM_WORKSPACE_COHORT_COLLABORATOR_SUMMARY_OK = 'workspace.cohort.collaborator.summary.ok';
export const RTM_WORKSPACE_COHORT_COLLABORATOR_SUMMARY_ERROR = 'workspace.cohort.collaborator.summary.error';

export const RTM_WORKSPACE_COHORT_ACCOUNT_ENROLL = 'workspace.cohort.account.enroll';
export const RTM_WORKSPACE_COHORT_ACCOUNT_ENROLL_OK = 'workspace.cohort.account.enroll.ok';
export const RTM_WORKSPACE_COHORT_ACCOUNT_ENROLL_ERROR = 'workspace.cohort.account.enroll.error';

export const RTM_WORKSPACE_COHORT_PERMISSION_GRANT = 'workspace.cohort.permission.grant';
export const RTM_WORKSPACE_COHORT_PERMISSION_GRANT_OK = 'workspace.cohort.permission.grant.ok';
export const RTM_WORKSPACE_COHORT_PERMISSION_GRANT_ERROR = 'workspace.cohort.permission.grant.error';

export const RTM_WORKSPACE_COHORT_PERMISSION_REVOKE = 'workspace.cohort.permission.revoke';
export const RTM_WORKSPACE_COHORT_PERMISSION_REVOKE_OK = 'workspace.cohort.permission.revoke.ok';
export const RTM_WORKSPACE_COHORT_PERMISSION_REVOKE_ERROR = 'workspace.cohort.permission.revoke.error';

export const RTM_WORKSPACE_COHORT_ARCHIVE = 'workspace.cohort.archive';
export const RTM_WORKSPACE_COHORT_ARCHIVE_OK = 'workspace.cohort.archive.ok';
export const RTM_WORKSPACE_COHORT_ARCHIVE_ERROR = 'workspace.cohort.archive.error';

export const RTM_WORKSPACE_COHORT_ENROLLMENTS_LIST = 'workspace.cohort.enrollment.list';
export const RTM_WORKSPACE_COHORT_ENROLLMENTS_LIST_OK = 'workspace.cohort.enrollment.list.ok';
export const RTM_WORKSPACE_COHORT_ENROLLMENTS_LIST_ERROR = 'workspace.cohort.enrollment.list.error';

export const RTM_WORKSPACE_DEPLOYMENT_LIST = 'workspace.deployment.list';
export const RTM_WORKSPACE_DEPLOYMENT_LIST_OK = 'workspace.deployment.list.ok';
export const RTM_WORKSPACE_DEPLOYMENT_LIST_ERROR = 'workspace.deployment.list.error';

export const RTM_IAM_TEAM_CREATE = 'iam.team.create';
export const RTM_IAM_TEAM_CREATE_OK = 'iam.team.create.ok';
export const RTM_IAM_TEAM_CREATE_ERROR = 'iam.team.create.error';

export const RTM_IAM_TEAM_LIST = 'iam.team.list';
export const RTM_IAM_TEAM_LIST_OK = 'iam.team.list.ok';
export const RTM_IAM_TEAM_LIST_ERROR = 'iam.team.list.error';

export const RTM_WORKSPACE_LIST = 'workspace.list';
export const RTM_WORKSPACE_LIST_OK = 'workspace.list.ok';
export const RTM_WORKSPACE_LIST_ERROR = 'workspace.list.error';

export const RTM_WORKSPACE_CREATE = 'workspace.create';
export const RTM_WORKSPACE_CREATE_OK = 'workspace.create.ok';
export const RTM_WORKSPACE_CREATE_ERROR = 'workspace.create.error';

export const RTM_WORKSPACE_PERMISSION_GRANT = 'workspace.permission.grant';
export const RTM_WORKSPACE_PERMISSION_GRANT_OK = 'workspace.permission.grant.ok';
export const RTM_WORKSPACE_PERMISSION_GRANT_ERROR = 'workspace.permission.grant.error';

export const RTM_WORKSPACE_PERMISSION_REVOKE = 'workspace.permission.revoke';
export const RTM_WORKSPACE_PERMISSION_REVOKE_OK = 'workspace.permission.revoke.ok';
export const RTM_WORKSPACE_PERMISSION_REVOKE_ERROR = 'workspace.permission.revoke.error';

export const RTM_WORKSPACE_COLLABORATOR_SUMMARY = 'workspace.collaborator.summary';
export const RTM_WORKSPACE_COLLABORATOR_SUMMARY_OK = 'workspace.collaborator.summary.ok';
export const RTM_WORKSPACE_COLLABORATOR_SUMMARY_ERROR = 'workspace.collaborator.summary.error';

export const RTM_PROJECT_INGEST_LIST = 'project.ingest.list';
export const RTM_PROJECT_INGEST_LIST_OK = 'project.ingest.list.ok';
export const RTM_PROJECT_INGEST_LIST_ERROR = 'project.ingest.list.error';

/** TO BE DEPRECATED */
export const RTM_WORKSPACE_ACTIVITY_PUBLISH = 'workspace.activity.publish';
export const RTM_WORKSPACE_ACTIVITY_PUBLISH_OK = 'workspace.activity.publish.ok';
export const RTM_WORKSPACE_ACTIVITY_PUBLISH_ERROR = 'workspace.activity.publish.error';

export const RTM_WORKSPACE_COURSEWARE_META_INFO_GET = 'workspace.courseware.meta.info.get';
export const RTM_WORKSPACE_COURSEWARE_META_INFO_GET_OK = 'workspace.courseware.meta.info.get.ok';
export const RTM_WORKSPACE_COURSEWARE_META_INFO_GET_ERROR = 'workspace.courseware.meta.info.get.error';

export const RTM_WORKSPACE_COURSEWARE_META_INFO_SET = 'workspace.courseware.meta.info.set';
export const RTM_WORKSPACE_COURSEWARE_META_INFO_SET_OK = 'workspace.courseware.meta.info.set.ok';
export const RTM_WORKSPACE_COURSEWARE_META_INFO_SET_ERROR = 'workspace.courseware.meta.info.set.error';

export const RTM_IAM_TEAM_PERMISSION_GRANT = 'iam.team.permission.grant';
export const RTM_IAM_TEAM_PERMISSION_GRANT_OK = 'iam.team.permission.grant.ok';
export const RTM_IAM_TEAM_PERMISSION_GRANT_ERROR = 'iam.team.permission.grant.error';

export const RTM_IAM_TEAM_PERMISSION_REVOKE = 'iam.team.permission.revoke';
export const RTM_IAM_TEAM_PERMISSION_REVOKE_OK = 'iam.team.permission.revoke.ok';
export const RTM_IAM_TEAM_PERMISSION_REVOKE_ERROR = 'iam.team.permission.revoke.error';

export const RTM_IAM_TEAM_ACCOUNT_SUMMARY = 'iam.team.account.summary';
export const RTM_IAM_TEAM_ACCOUNT_SUMMARY_OK = 'iam.team.account.summary.ok';
export const RTM_IAM_TEAM_ACCOUNT_SUMMARY_ERROR = 'iam.team.account.summary.error';

export const RTM_WORKSPACE_PLUGIN_DELETE = 'workspace.plugin.delete';
export const RTM_WORKSPACE_PLUGIN_DELETE_OK = 'workspace.plugin.delete.ok';
export const RTM_WORKSPACE_PLUGIN_DELETE_ERROR = 'workspace.plugin.delete.error';

export const RTM_WORKSPACE_PROJECT_LIST = 'workspace.project.list';
export const RTM_WORKSPACE_PROJECT_LIST_OK = 'workspace.project.list.ok';
export const RTM_WORKSPACE_PROJECT_LIST_ERROR = 'workspace.project.list.error';

export const RTM_WORKSPACE_PROJECT_CREATE = 'workspace.project.create';
export const RTM_WORKSPACE_PROJECT_CREATE_OK = 'workspace.project.create.ok';
export const RTM_WORKSPACE_PROJECT_CREATE_ERROR = 'workspace.project.create.error';

export const RTM_PROJECT_ACTIVITY_PUBLISH = 'project.activity.publish';
export const RTM_PROJECT_ACTIVITY_PUBLISH_OK = 'project.activity.publish.ok';
export const RTM_PROJECT_ACTIVITY_PUBLISH_ERROR = 'project.activity.publish.error';

export const RTM_PUBLICATION_ACTIVITY_FETCH = 'publication.activity.fetch';
export const RTM_PUBLICATION_ACTIVITY_FETCH_OK = 'publication.activity.fetch.ok';
export const RTM_PUBLICATION_ACTIVITY_FETCH_ERROR = 'publication.activity.fetch.error';
